function determineDataUrl(item: any): string {
  switch (item.drive) {
    case "BELT":
      return "bwc/lopro/belt_and_chain_systems/belt_and_chain_system_asmtab.prj";
    case "CHAIN":
      return "bwc/lopro/belt_and_chain_systems/belt_and_chain_system_asmtab.prj";
    case "LEAD SCREW":
      return "bwc/lopro/lead_screw_ball_screw_systems/lead_screw_ball_screw_systems_asmtab.prj";
    case "BALL SCREW":
      return "bwc/lopro/lead_screw_ball_screw_systems/lead_screw_ball_screw_systems_asmtab.prj";
    default:
      return "";
  }
}

function determineProductCode(item: any): string {
  switch (item.drive) {
    case "BELT":
      return "LPBLTCHN";
    case "CHAIN":
      return "LPBLTCHN";
    case "LEAD SCREW":
      return "LPSCREW";
    case "BALL SCREW":
      return "LPSCREW";
    default:
      return "";
  }
}

function determineDriveType(item: any): string {
  switch (item.drive) {
    case "BELT":
      return "B::B";
    case "CHAIN":
      return "C::C";
    case "LEAD SCREW":
      return "L::LS";
    case "BALL SCREW":
      return "S::BS";
    default:
      return "";
  }
}

function determineSystemSize(item: any): string {
  switch (item.systemSize) {
    case "1":
      return "1Z::1";
    case "2":
      return "2Z::2";
    case "2S":
      return "2S::2S";
    case "2L":
      return "2L::2L";
    case "3":
      return "3Z::3";
    case "4":
      return "4Z::4";
    default:
      return "";
  }
}

function determineSystemMaterial(item: any): string {
  switch (item.systemMaterial) {
    case "Carbon Steel":
      return "C::C";
    case "Stainless Steel":
      return "S::CR";
    default:
      return "";
  }
}

export function configuredClicked(item: any, travelDistance: number) {
  const formData = new FormData();
  formData.append("product_code", determineProductCode(item));
  formData.append("data-url", determineDataUrl(item));
  const params = new URLSearchParams(window.location.search);
  // @ts-ignore
  const formKeyFromUrl: string = params.get('form_key');
  formData.append("form_key", formKeyFromUrl);
  const baseUrl = `https://${window.location.hostname}/configurator/configurator/view/`;
  fetch(baseUrl, {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((text) => {
      const ssData: any = {
        react_p: "lopro",
        react_product_code: determineProductCode(item),
        react_drivetype_2: item.driveType,
        react_systemsize_3: item.systemSizeStr,
        react_systemmaterial_4: item.sytemMaterial,
        react_nutoption_7: item.nutOption,
        react_t1: travelDistance.toString(),
      };
      for (const key in ssData) {
        sessionStorage.setItem(key, ssData[key]);
      }
      window.open(`/configurator/configurator/view/?product_code=${determineProductCode(item)}&data_url=${determineDataUrl(item)}`, '_blank');
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
    });
}
